use '@use-gpu/wgsl/oit/oit'::{ getOITSample };

@optional @link fn getFragment(color: vec4<f32>, uv: vec4<f32>, st: vec4<f32>) -> vec4<f32> { return color; }
@optional @link fn getScissor(color: vec4<f32>, scissor: vec4<f32>) -> vec4<f32> { return color; }

struct OITBufferSample {
  @location(0) color: vec4<f32>,
  @location(1) alpha: vec4<f32>,
};

@fragment
fn main(
  @builtin(position) fragCoord: vec4<f32>,
  @location(0) fragColor: vec4<f32>,
  @location(1) fragUV: vec4<f32>,
  @location(2) fragST: vec4<f32>,
  @location(3) fragScissor: vec4<f32>,
) -> OITBufferSample {
  var outColor = fragColor;
  outColor = getFragment(outColor, fragUV, fragST);

  if (HAS_SCISSOR) { outColor = getScissor(outColor, fragScissor); }
  if (HAS_ALPHA_TO_DISCARD) { if (outColor.a <= 0.0) { discard; } }

  let sample = getOITSample(outColor, fragCoord.z);

  return OITBufferSample(sample.color, vec4<f32>(sample.alpha));
}
